import { GET, POST } from "../_helpers/Fetch";
import {
  ACCESS_REQUEST_USERS,
  ACCESS_REQUEST_ORGANIZATION,
  APPROVE_ORGANIZATION,
  APPROVE_USER,
  USERS,
  GET_ALL_ORGANIZATIONS,
  EXPORT_ALL_ORGANIZATIONS,
  UPDATE_ORGANIZATION,
  COUNTRIES,
  ANNOUNCEMENTS,
  UPDATE_ANNOUNCEMENTS,
  DELETE_ANNOUNCEMENTS,
  CREATE_ANNOUNCEMENT,
  STOREADMIN_GETORG,
  STOREADMIN_GETUSER,
  ORDER_SEARCH,
  ORDER_GET,
  ORDER_UPDATE,
  SUBSCRIPTIONS_GET,
  SUBSCRIPTIONS_CANCEL,
  SUPER_ADMIN_UPDATE_USER,
  TOOLS_AND_LIB_UPDATE_USER,
  EXPORT_ALL_USERS
} from "../_constants/AdminAPI";
import { UrlFilterHelper } from "../_helpers/UrlFilterHelper";
import { UserRole } from "../_constants/UserRole";
import axios from "axios";

export const adminService = {
  GetAccessRequestUsers,
  GetAccessRequestOrganizations,
  ApproveOrganization,
  ApproveUser,
  AdminGetUsers,
  ExportAllUsers,
  UpdateUser,
  GetAnnouncements,
  UpdateAnnouncement,
  DeleteAnnouncement,
  CreateAnnouncement,
  GetOrganizations,
  ExportAllOrganizations,
  UpdateOrganization,
  GetAllCountries,
  SearchOrder,
  GetOrder,
  UpdateOrder,
  GetSubscription,
  CancelSubscription,
};

async function GetAccessRequestUsers(
  skipCount,
  search = null,
  orderBy = null,
  dsc = false
) {
  try {
    var url = ACCESS_REQUEST_USERS;
    url = UrlFilterHelper.GetFilterdUrl(url, skipCount, search, orderBy, dsc);

    const { data: UserObject } = await GET(url);
    return UserObject;
  } catch (err) {
    return null;
  }
}

async function GetAccessRequestOrganizations(
  skipCount,
  search = null,
  orderBy = null,
  dsc = false
) {
  try {
    var url = ACCESS_REQUEST_ORGANIZATION;
    url = UrlFilterHelper.GetFilterdUrl(url, skipCount, search, orderBy, dsc);

    const { data: OrgObj } = await GET(url);
    return OrgObj;
  } catch (err) {
    return null;
  }
}

async function ApproveOrganization(organizationDto) {
  try {
    const { data: Response } = await POST(
      APPROVE_ORGANIZATION,
      organizationDto
    );
    return Response;
  } catch (err) {
    return null;
  }
}

async function ApproveUser(userDTO) {
  try {
    const { data: Response } = await POST(APPROVE_USER, userDTO);
    return Response;
  } catch (err) {
    return null;
  }
}

async function AdminGetUsers(
  roleId,
  skipCount,
  search = null,
  orderBy = null,
  dsc = false
) {
  try {
    var url = "";
    if (roleId == UserRole.ToolsAdmin_Entitlement) {
      url = USERS + "/ToolsAdminGetUsers";
    } else if (roleId >= UserRole.SuperAdmin_Entitlement) {
      url = USERS + "/SuperAdminGetUsers";
    }
    url = UrlFilterHelper.GetFilterdUrl(url, skipCount, search, orderBy, dsc);
    return await GET(url);
  } catch (err) {
    return null;
  }
}

async function ExportAllUsers() {
    return axios.get(EXPORT_ALL_USERS, {
    responseType: "blob",
  });
}

async function UpdateUser(id, updateUserDto, roleId) {
  const response = await POST((roleId === UserRole.SuperAdmin_Entitlement 
    ? SUPER_ADMIN_UPDATE_USER  : TOOLS_AND_LIB_UPDATE_USER) + id, updateUserDto).catch(error => {return error});
  return response;
}

async function GetOrganizations(
  roleId,
  skipCount,
  search = null,
  orderBy = null,
  dsc = false
) {
  try {
    var url = "";
    if (roleId == UserRole.StoreAdmin_Entitlement) {
      url = STOREADMIN_GETORG;
    } else if (roleId >= UserRole.ToolsAdmin_Entitlement) {
      url = GET_ALL_ORGANIZATIONS;
    }
    url = UrlFilterHelper.GetFilterdUrl(url, skipCount, search, orderBy, dsc);
    const { data: Organizations } = await GET(url);
    return Organizations;
  } catch (err) {
    return null;
  }
}

async function ExportAllOrganizations() {
  return axios.get(EXPORT_ALL_ORGANIZATIONS, {
  responseType: "blob",
});
}

async function UpdateOrganization(id, updateOrganizationDto) {
  try {
    const { data: Response } = await POST(
      UPDATE_ORGANIZATION + id,
      updateOrganizationDto
    );
    return Response;
  } catch (err) {
    return null;
  }
}

async function GetAllCountries() {
  try {
    const { data: Countries } = await GET(COUNTRIES);
    return Countries;
  } catch (err) {
    return null;
  }
}

async function GetAnnouncements(state, skipCount) {
  try {
    let url = ANNOUNCEMENTS;
    url = url.replace("{0}", state);
    url = url.replace("{1}", skipCount);

    const { data: Announcements } = await GET(url);
    return Announcements;
  } catch (err) {
    return null;
  }
}

async function UpdateAnnouncement(id, updateAnnouncementDto) {
  try {
    const { data: Response } = await POST(
      UPDATE_ANNOUNCEMENTS + id,
      updateAnnouncementDto
    );
    return { success: true, message: Response.message, data: Response };
  } catch (err) {
    return null;
  }
}

async function DeleteAnnouncement(id) {
  try {
    const { data: Response } = await POST(DELETE_ANNOUNCEMENTS + id);
    return { success: true, message: Response.message, data: Response };
  } catch (err) {
    return null;
  }
}

async function CreateAnnouncement(AnnouncementDTO) {
  try {
    const { data: Response } = await POST(CREATE_ANNOUNCEMENT, AnnouncementDTO);
    return { success: true, message: Response.message, data: Response };
  } catch (err) {
    return { success: false, error: { message: err.message || 'Unknown error occurred' } };
  }
}

function SearchOrder(skipCount, sorting, dsc, filter) {
  function prepareFilterParams(
    skipCount = 0,
    sorting = null,
    dsc = false,
    filter = null
  ) {
    if (dsc) {
      sorting += " desc";
    }

    let data = {
      skipCount: skipCount,
      sorting: sorting,
      orderStatus: filter.orderStatus,
      orderId: filter.orderId,
    };

    return data;
  }

  let data = prepareFilterParams(skipCount, sorting, dsc, filter);
  return axios.post(ORDER_SEARCH, data);
}

function GetOrder(id) {
  return axios.get(ORDER_GET + id);
}

function UpdateOrder(data) {
  return axios.post(ORDER_UPDATE, data);
}

function GetSubscription(id) {
    return axios.get(SUBSCRIPTIONS_GET + id); // Returns: ApiResponse<OrganizationProductSubscriptionDto>
}

function CancelSubscription(subscriptionCancelDto) {
    return axios.post(SUBSCRIPTIONS_CANCEL + subscriptionCancelDto.id, subscriptionCancelDto); // Returns: ApiResponse<OrganizationProductSubscriptionDto>
}
